import { computed, inject, Injectable, Signal } from '@angular/core';

import { Flags, LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { MainQuery } from '@shared/store/main/main.query';
import { TrialsQuery } from '@shared/store/trials/trials.query';

@Injectable({
  providedIn: 'root',
})
export class CmcService {
  private launchDarklyService = inject(LaunchDarklyService);
  private mainQuery = inject(MainQuery);
  private trialsQuery = inject(TrialsQuery);

  isTabVisibleForCmc(flagKey: keyof Flags): Signal<boolean> {
    return computed(() => {
      const flag = this.launchDarklyService.$select((flags) => flags[`${flagKey}`]);
      const isCurrentTrialCMC = this.trialsQuery.isCurrentTrialCMC(
        this.mainQuery.mainState().trialKey
      )();

      return !!(flag() && !isCurrentTrialCMC);
    });
  }
}
